module.exports = __webpack_public_path__ + "assets/not-wechat-title-5f7cc537.png";